import { render } from "./create-supplier.vue?vue&type=template&id=49b9cc16"
import script from "./create-supplier.vue?vue&type=script&lang=js"
export * from "./create-supplier.vue?vue&type=script&lang=js"

import "./create-supplier.vue?vue&type=style&index=0&id=49b9cc16&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__